import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "customer"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    getResume(type, param, allStatus = false) {

        return http.getResume(path,type,param,allStatus);

    }

}

export default new service();


